// extracted by mini-css-extract-plugin
export default {"container":"style_container__w+GmO","page":"style_page__jyoKk","error":"style_error__ED+6-"};